export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9669.1139d58e.jpg";